(function () {
  const TIERS = [
    { cents: 100000, label: '15% OFF', percent: 15 },
    { cents: 250000, label: '20% OFF', percent: 20 },
    { cents: 450000, label: '25% OFF', percent: 25 }
  ];

  function getCartConfig() {
    const el = document.getElementById('cart-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getDrawerRoot() {
    return document.querySelector('.ajax-cart__drawer-wrapper.mt-cart-drawer');
  }

  function updatePromo(cart) {
    const root = getDrawerRoot();
    if (!root) return;

    const promo = root.querySelector('[data-mt-cart-promo]');
    const message = root.querySelector('[data-mt-promo-message]');
    const fill = root.querySelector('[data-mt-promo-fill]');
    const milestones = Array.from(root.querySelectorAll('[data-mt-tier]'));

    if (!promo || !cart || cart.item_count < 1) {
      if (promo) promo.hidden = true;
      return;
    }

    promo.hidden = false;
    const total = cart.total_price || 0;
    const maxTier = TIERS[TIERS.length - 1].cents;
    const progress = Math.min(100, (total / maxTier) * 100);

    if (fill) fill.style.width = progress + '%';

    milestones.forEach((node) => {
      const tier = parseInt(node.getAttribute('data-mt-tier'), 10);
      node.classList.toggle('is-reached', total >= tier);
    });

    if (!message) return;

    const nextTier = TIERS.find((tier) => total < tier.cents);
    if (!nextTier) {
      message.textContent = "You've unlocked the maximum savings tier.";
      return;
    }

    const remaining = nextTier.cents - total;
    const config = getCartConfig();
    const money = formatMoney(remaining, config && config.money_format);
    message.textContent = "You're only " + money + ' away from ' + nextTier.label + '.';
  }

  function updateCheckoutButton(cart) {
    const config = getCartConfig();
    const checkoutLabel = 'Checkout';
    const totalText = cart && cart.total_price != null ? formatMoney(cart.total_price, config && config.money_format) : '';

    document.querySelectorAll('.ajax-cart__drawer-wrapper .mt-cart__checkout').forEach((btn) => {
      btn.value = totalText ? checkoutLabel + '·' + totalText : checkoutLabel;
    });
  }

  function applyDiscountCode(code) {
    const trimmed = (code || '').trim();
    if (!trimmed) return;

    const redirect = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.assign('/discount/' + encodeURIComponent(trimmed) + '?redirect=' + redirect);
  }

  function initDiscountApply() {
    document.addEventListener('click', function (event) {
      const button = event.target.closest('.ajax-cart__drawer-wrapper .js-cart-discount-apply');
      if (!button) return;

      event.preventDefault();
      const wrapper = button.closest('.js-cart-discount');
      const input = wrapper && wrapper.querySelector('.js-cart-discount-input');
      applyDiscountCode(input && input.value);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;

      const input = event.target.closest('.ajax-cart__drawer-wrapper .js-cart-discount-input');
      if (!input) return;

      event.preventDefault();
      applyDiscountCode(input.value);
    });
  }

  function bindRecommendationAtc(wrap) {
    const config = getCartConfig();
    if (!config || typeof Shopify === 'undefined' || !Shopify.theme || !Shopify.theme.ajaxCart) return;

    wrap.querySelectorAll('.mt-cart-drawer__rec-form .js-ajax-submit').forEach(function (btn) {
      if (btn.dataset.mtCartRecAtcBound === 'true') return;
      btn.dataset.mtCartRecAtcBound = 'true';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        const form = btn.closest('form');
        if (form) {
          Shopify.theme.ajaxCart.addToCart(form, btn.parentNode, config, false);
        }
        return false;
      });
    });
  }

  function applyRecommendationCollapse(wrap) {
    const visibleLimit = parseInt(wrap.dataset.visibleLimit, 10) || 1;
    const items = wrap.querySelectorAll('[data-mt-cart-rec-item]');
    const toggle = wrap.querySelector('[data-mt-cart-recommendations-toggle]');

    wrap.classList.remove('mt-cart-drawer__recommendations--expanded');

    items.forEach(function (item, index) {
      item.classList.toggle('is-collapsed', index >= visibleLimit);
    });

    if (items.length > visibleLimit && toggle) {
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', 'false');
      const label = toggle.querySelector('[data-mt-cart-recommendations-toggle-label]');
      if (label) {
        label.textContent = toggle.dataset.viewMoreLabel || 'View More';
      }
    } else if (toggle) {
      toggle.hidden = true;
    }
  }

  function bindRecommendationToggle(wrap) {
    const toggle = wrap.querySelector('[data-mt-cart-recommendations-toggle]');
    if (!toggle || toggle.dataset.mtCartRecToggleBound === 'true') return;

    toggle.dataset.mtCartRecToggleBound = 'true';
    const moreLabel = toggle.dataset.viewMoreLabel || 'View More';
    const lessLabel = toggle.dataset.viewLessLabel || 'View Less';
    const label = toggle.querySelector('[data-mt-cart-recommendations-toggle-label]');

    toggle.addEventListener('click', function () {
      const expanded = wrap.classList.toggle('mt-cart-drawer__recommendations--expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) {
        label.textContent = expanded ? lessLabel : moreLabel;
      }
    });
  }

  function loadCartRecommendations(cart) {
    const root = getDrawerRoot();
    if (!root) return;

    const wrap = root.querySelector('[data-mt-cart-recommendations]');
    if (!wrap) return;

    const list = wrap.querySelector('[data-mt-cart-recommendations-list]');
    if (!list) return;

    if (!cart || !cart.items || cart.items.length < 1) {
      wrap.classList.add('hide');
      wrap.hidden = true;
      list.innerHTML = '';
      return;
    }

    wrap.classList.remove('hide');

    const productId = cart.items[0].product_id;
    const baseUrl = wrap.dataset.baseUrl;
    const sectionId = wrap.dataset.sectionId;
    const limit = wrap.dataset.recommendationLimit || '4';

    if (!baseUrl || !productId || !sectionId) {
      wrap.hidden = true;
      return;
    }

    if (wrap.dataset.mtCartRecProductId === String(productId) && wrap.dataset.mtCartRecLoaded === 'true') {
      wrap.hidden = false;
      return;
    }

    wrap.dataset.mtCartRecProductId = String(productId);
    wrap.dataset.mtCartRecLoaded = 'false';
    list.innerHTML = '';

    const url =
      baseUrl +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(limit);

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        if (!html || !html.trim()) {
          wrap.hidden = true;
          wrap.dataset.mtCartRecLoaded = 'true';
          return;
        }

        const temp = document.createElement('div');
        temp.innerHTML = html;
        const sectionEl = temp.querySelector('.shopify-section');
        const content = sectionEl ? sectionEl.innerHTML : html;

        if (!content.trim()) {
          wrap.hidden = true;
          wrap.dataset.mtCartRecLoaded = 'true';
          return;
        }

        list.innerHTML = content;
        wrap.dataset.mtCartRecLoaded = 'true';
        wrap.hidden = false;

        const items = list.querySelectorAll('[data-mt-cart-rec-item]');
        if (items.length === 0) {
          wrap.hidden = true;
          return;
        }

        applyRecommendationCollapse(wrap);
        bindRecommendationToggle(wrap);
        bindRecommendationAtc(wrap);
      })
      .catch(function () {
        wrap.hidden = true;
        wrap.dataset.mtCartRecLoaded = 'true';
      });
  }

  function onCartUpdated(cart) {
    updatePromo(cart);
    updateCheckoutButton(cart);
    loadCartRecommendations(cart);
  }

  window.openCartDrawer = function openCartDrawer() {
    const config = getCartConfig();
    if (!config || config.cart_action !== 'drawer') return false;
    if (typeof Shopify === 'undefined' || !Shopify.theme || !Shopify.theme.ajaxCart) return false;

    return Shopify.theme.cart.getCart().then(function (Cart) {
      Shopify.theme.ajaxCart.updateView(config, Cart);
      Shopify.theme.ajaxCart.showDrawer(config);
      onCartUpdated(Cart);
      return Cart;
    });
  };

  document.addEventListener('mt:cart:updated', function (event) {
    if (event.detail && event.detail.cart) onCartUpdated(event.detail.cart);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initDiscountApply();

    if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cart) {
      Shopify.theme.cart.getCart().then(onCartUpdated).catch(function () {});
    }
  });
})();
